import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'components/Link';
import { unibrow as UnibrowPropType } from 'lib/CustomPropTypes';

const block = 'unibrow';

const Unibrow = ({
  children,
  className,
  size: HTag,
  target,
  unibrow,
}) => {
  if (!unibrow) return null;

  let element = (
    <span>
      {unibrow.override || unibrow.text || ''}
    </span>
  );

  if (unibrow && unibrow.url && unibrow.url.primary) {
    const unibrowUrl = unibrow.url.override || unibrow.url.primary;
    element = (
      <Link href={unibrowUrl} target={target}>
        {element}
      </Link>
    );
  }

  return (
    <HTag className={classNames(block, 'articleTitleSection', className)}>
      {element}
      {children}
    </HTag>
  );
};

Unibrow.propTypes = {
  unibrow: UnibrowPropType.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  size: PropTypes.string,
  target: PropTypes.string,
};

Unibrow.defaultProps = {
  className: '',
  children: null,
  size: 'h2',
  target: null,
};

export default Unibrow;
